import axiosInstance from './axios';
import { CustomApiResponse } from './apiResponse';

/**
 * Result of the IP and Country compliance check.
 */
export interface IpCheckResult {
  ip: string;
  allowed: boolean;
  countryCode: string | null;
  countryName: string | null;
  error?: string;
}

/**
 * Calls the backend to check if the current user's IP is authorized.
 * @returns A promise resolving to the IpCheckResult data.
 */
export const isCountryAuthorized = async (): Promise<IpCheckResult> => {

  if (`${process.env.REACT_APP_API_URL}`.includes('localhost')) {
    return {
      ip: 'localhost',
      allowed: true,
      countryCode: 'FR',
      countryName: 'France (Dev)',
    };
  }

  try {
    const response = await axiosInstance.get<CustomApiResponse<IpCheckResult>>('/compliance/countries/ip/check');
    
    if (response.data.status === 'success') {
      return response.data.data;
    }
    
    throw new Error(response.data.error || 'Backend returned an error status');
  } catch (error) {
    console.error('Compliance Check Error:', error);
    throw error;
  }
};